import { from } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { matchPath } from 'react-router';
import Paths from 'AppPaths';

/**
 * Middleware function for subscribing to a specific socket room based on the action payload.
 *
 * @param {Object} socket - The socket object used to subscribe to rooms.
 */
export const socketMiddleware = socket => store => next => async action => {
  const { getState } = store;
  const targetedActions = [`@@router/LOCATION_CHANGE`];
  from([action])
    .pipe(
      filter($action => targetedActions.includes($action.type)),
      take(1)
    )
    .subscribe($action => {
      const {
        location: { pathname: currLocation }
      } = $action.payload;
      const prevLocation = getState().router.location.pathname;

      const getTeamId = path =>
        matchPath(path, { path: Paths.TeamDash })?.params?.teamId;

      const prevTeamId = getTeamId(prevLocation);
      const currentTeamId = getTeamId(currLocation);

      if (
        currentTeamId &&
        !socket._subscriptions.includes(`team.${currentTeamId}`)
      ) {
        socket.subscribe(`team.${currentTeamId}`, currentTeamId);
      }

      if (prevTeamId && prevTeamId !== currentTeamId) {
        socket.unsubscribe(`team.${prevTeamId}`);
      }
    });

  return next(action);
};

export default socketMiddleware;
